var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-time-picker',{staticClass:"filter-timepicker",attrs:{"name":_vm.config.name,"format":"HH:mm","placeholder":_vm.$t('base.placeholder.selectTime'),"size":"small"},on:{"change":_vm.value},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }